/**
 * Role-based utility functions for checking user permissions
 */

/**
 * Get the current user's role from localStorage
 * @returns {string} The user's role or empty string if not found
 */
export function getCurrentUserRole() {
  return localStorage.getItem("role") || "";
}

/**
 * Check if the current user has any of the specified roles
 * @param {string|string[]} allowedRoles - Single role or array of roles
 * @returns {boolean} True if user has one of the allowed roles
 */
export function hasRole(allowedRoles) {
  const currentRole = getCurrentUserRole();
  
  if (Array.isArray(allowedRoles)) {
    return allowedRoles.includes(currentRole);
  }
  
  return currentRole === allowedRoles;
}

/**
 * Check if user can access transfer functionality
 * @returns {boolean} True if user has finance or admin role
 */
export function canAccessTransfer() {
  return hasRole(["Finance", "Admin"]);
}

/**
 * Check if user can add balance
 * @returns {boolean} True if user has admin or finance role
 */
export function canAddBalance() {
  return hasRole(["Admin", "Finance"]);
}

/**
 * Check if user is admin
 * @returns {boolean} True if user has admin role
 */
export function isAdmin() {
  return hasRole("Admin");
}

/**
 * Check if user is finance
 * @returns {boolean} True if user has finance role
 */
export function isFinance() {
  return hasRole("Finance");
}

/**
 * Check if user is staff
 * @returns {boolean} True if user has staff role
 */
export function isStaff() {
  return hasRole("Staff");
}

/**
 * Check if user is IT
 * @returns {boolean} True if user has IT role
 */
export function isIT() {
  return hasRole("IT");
}
